
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { DEFAULT_COLOR_FOR_LOADER } from '@/constants';

export default defineComponent({
  name: 'Loading',
  computed: {
    ...mapGetters([
      'global'
    ]),
    backgroundColorForLoader (): string {
      return this.global.primaryColor || DEFAULT_COLOR_FOR_LOADER;
    }
  }
});
